
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PricingSection from './components/PricingSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import SignupSection from './components/SignupSection';

export default function EsHome() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ServicesSection />
      <PricingSection />
      <AboutSection />
      <SignupSection />
      <ContactSection />
      <Footer />
    </div>
  );
}